// NPM Imports
import React, { Suspense } from "react";
// import { useDispatch } from "react-redux";
import Modal from "react-responsive-modal";

// Components Imports
import {
  ConfirmationBox,
  LazyLoad,
  UpgradePopUpV2,
} from "../../../commonComponents";
import ManageColumnsPopup from "../ManageColumnsPopup";
import CustomImageAltTextPopup from "../CustomImageAltTextPopup";
import PlanChangeRequest from "../../SettingsWrapper/BillingSettings/PlanChangeRequest";

// Actions Imports

// Services Imports

// Internal Imports
import { FEATURES } from "../../../constants";
import { GlobalUtils } from "../../../utils";
import LZLoader from "../../../commonComponents/LZLoader";

const CreateClauseLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "create-clause-page" */ "../../Document/CreateClause"
  ),
);

// Destructuring
const { FEATURES_NAME } = FEATURES;
const { isFreeBillingPlan, truncateString } = GlobalUtils;

export default function DocumentItemPopups({
  sectionLabel,
  toggleUpgradePopup,
  openModal,
  showClauseSave,
  sectionIdForClause,
  showDeleteConfirmation,
  showRemoveClauseConfirmation,
  showRemoveClauseOptionsConfirmation,
  showRemoveTableFormField,
  showManageColumnPopup,
  createClause,
  closePopup,
  updateDocumentClickedComponentID,
  updateStateKey,
  deleteSection,
  docDeletePopupRef,
  columnsHeaders,
  setMngColsData,
  removeClause,
  removeClauseOption,
  showContentLockUpgradePopup,
  showAddClauseUpgradePopup,
  section,
  updateComponent,
}) {
  // custom image alttext save popup
  if (openModal) {
    return (
      <CustomImageAltTextPopup
        closePopup={closePopup}
        section={section}
        updateComponent={updateComponent}
      />
    );
  }

  if (showClauseSave) {
    return (
      <Modal
        open={showClauseSave}
        center
        closeOnOverlayClick={false}
        onClose={() => updateStateKey("showClauseSave", false)}>
        <Suspense fallback={<LZLoader label="Please wait..." largeLabel />}>
          <CreateClauseLazy
            sectionId={sectionIdForClause}
            closePopup={() => updateStateKey("showClauseSave", false)}
            confirmAction={createClause}
            updateDocumentClickedComponentID={updateDocumentClickedComponentID}
          />
        </Suspense>
      </Modal>
    );
  }

  const showLabel = sectionLabel ? ` "${sectionLabel}"` : "";
  if (showDeleteConfirmation) {
    const label = showLabel === "" ? "" : truncateString(showLabel, 60, true);
    return (
      <ConfirmationBox
        show={showDeleteConfirmation}
        name="doc-delete-section"
        closePopup={() => updateStateKey("showDeleteConfirmation", false)}
        header={`Are you sure you want to DELETE this section ${label} ?`}
        subHeader={`Once deleted, you won't be able to undo this action.`}
        checkboxLabel="Yes, I want to delete."
        confirmAction={deleteSection}
        okBtnText="Delete Section"
        disableCheckbox
        confirmationBoxRef={docDeletePopupRef}
      />
    );
  }
  if (showManageColumnPopup) {
    return (
      <ManageColumnsPopup
        show={showManageColumnPopup}
        closePopup={() => updateStateKey("showManageColumnPopup", false)}
        columns={columnsHeaders}
        setMngColsData={setMngColsData}
      />
    );
  }
  if (showRemoveClauseConfirmation) {
    return (
      <ConfirmationBox
        show={showRemoveClauseConfirmation}
        name="remove-clause"
        closePopup={() => updateStateKey("showRemoveClauseConfirmation", false)}
        header={`Are you sure you want to Remove Clause with this section ${showLabel} ?`}
        subHeader={`Once removed, you won't be able to add this clause.`}
        checkboxLabel="Yes, I want to remove."
        confirmAction={removeClause}
        okBtnText="REMOVE CLAUSE"
        confirmationBoxRef={docDeletePopupRef}
      />
    );
  }
  if (showRemoveClauseOptionsConfirmation) {
    return (
      <ConfirmationBox
        show={showRemoveClauseOptionsConfirmation}
        name="remove-clause-options"
        closePopup={() =>
          updateStateKey("showRemoveClauseOptionsConfirmation", false)
        }
        header={`Are you sure you want to Remove Clause Options with this section ${showLabel} ?`}
        subHeader="Once removed, you will not be able to undo the process. Any workflows associated with this clause also will be removed."
        checkboxLabel="Yes, I want to remove."
        confirmAction={removeClauseOption}
        okBtnText="REMOVE CLAUSE OPTIONS"
        confirmationBoxRef={docDeletePopupRef}
      />
    );
  }
  if (showRemoveTableFormField) {
    return (
      <ConfirmationBox
        show={showRemoveTableFormField}
        name="remove-image-form-field"
        closePopup={() => updateStateKey("showRemoveTableFormField", false)}
        header="Are you sure you want to Remove table field with this section ?"
        subHeader="Once removed, you will not be able to undo the process. Any workflows associated with this table field also will be removed."
        checkboxLabel="Yes, I want to remove."
        confirmAction={() => {}}
        okBtnText="REMOVE PLACEHOLDER"
      />
    );
  }

  // This is for upgrade popups of ConentLock/Add Clause Option
  let contentUpgradePopup = null;
  let featureName = "";
  let decideType = "";
  if (showContentLockUpgradePopup) {
    featureName = FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING;
    decideType = "showContentLockUpgradePopup";
  } else if (showAddClauseUpgradePopup) {
    featureName = FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS;
    decideType = "showAddClauseUpgradePopup";
  }
  if (showContentLockUpgradePopup || showAddClauseUpgradePopup) {
    contentUpgradePopup = isFreeBillingPlan() ? (
      <UpgradePopUpV2
        type={featureName}
        onClose={() => toggleUpgradePopup(decideType, false)}
      />
    ) : (
      <PlanChangeRequest
        onClose={() => toggleUpgradePopup(decideType, false)}
      />
    );

    return contentUpgradePopup;
  }

  return null;
}
